import { OrderTargetBreakdownRow, ToOrderTargetBreakdownRowsParams } from './orderTargets.types';

export const toOrderTargetBreakdownRows = ({
  items,
  calculatedAt,
}: ToOrderTargetBreakdownRowsParams): OrderTargetBreakdownRow[] =>
  items
    .filter((item) => item.parentId === null)
    .map((item) => ({
      id: item.id,
      label: item.label,
      attainedValue: item.attained,
      plannedValue: item.plannedValue,
      attainment: {
        attainedByStatus: item.attainedByStatus,
        conversion: item.conversion,
        calculatedAt,
      },
    }));
